import { render, staticRenderFns } from "./CustomerEdit.vue?vue&type=template&id=7a225429&scoped=true"
import script from "./CustomerEdit.vue?vue&type=script&lang=js"
export * from "./CustomerEdit.vue?vue&type=script&lang=js"
import style0 from "./CustomerEdit.vue?vue&type=style&index=0&id=7a225429&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a225429",
  null
  
)

export default component.exports